import "./index.css";
export default function Comprar(){
    return(
        <button className="bttn">Comprar</button>
    )
}